EmailFormUSLocationListElementView = require "./location_list_element_view"
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormUSLocationListRowView extends Backbone.View
  tagName: 'tr'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    _.bindAll.apply(_, [this].concat(_.functions(this)))

  render: ->
    elements = @options.elements
    for element in elements
      locationView = new EmailFormUSLocationListElementView
        location: element
      @$el.append(locationView.el)
      locationView.render()

module.exports = EmailFormUSLocationListRowView
